import LeaveStatusField from 'domain/people/leave/shared/field/LeaveStatusField';
import { useShowContext } from 'framework/show';
import { MappedLeaveItem } from '../../shared/types';

interface BalancesLeavesStatusFieldProps {
  value?: MappedLeaveItem;
}

const BalancesLeavesStatusField = ({ value }: BalancesLeavesStatusFieldProps) => {
  const { data } = useShowContext<MappedLeaveItem>();
  const contextLeave = data?.getData();
  const leave = value || contextLeave;
  return <LeaveStatusField value={leave?.status} />;
};

export default BalancesLeavesStatusField;
